import { Button } from "@zapier/design-system";
import Loading from "./Loading";

interface LoadingButtonProps extends React.ComponentProps<typeof Button> {
  loading?: boolean;
}

export default function LoadingButton({
  loading,
  children,
  disabled,
  ...buttonProps
}: LoadingButtonProps) {
  return (
    <Button {...buttonProps} disabled={disabled || loading}>
      {loading ? <Loading /> : children}
    </Button>
  );
}
